<template>
  <article class="ai-attempt">
    <div class="ai-attempt__header">
      <strong>Attempt {{ attempt.attempt_number }}</strong>
      <v-chip :color="runStatusColor(attempt.status)">
        {{ formatRunStatus(attempt.status) }}
      </v-chip>
    </div>

    <div v-if="durationLabel !== '—' || taxonomyLabel" class="ai-attempt__meta">
      <span v-if="durationLabel !== '—'">{{ $t("ncrm.ai.runs.labels.duration") }}: {{ durationLabel }}</span>
      <span v-if="taxonomyLabel">{{ taxonomyLabel }}</span>
    </div>

    <div v-if="errorMessage" class="ai-attempt__error-block">
      <span class="ai-summary-card__label">{{ $t("ncrm.ai.runs.labels.rootCause") }}</span>
      <p class="ai-attempt__error-message">{{ errorMessage }}</p>
    </div>

    <div v-if="diagnostics" class="ai-summary-card ai-summary-card--nested">
      <span class="ai-summary-card__label">{{ $t("ncrm.ai.runs.labels.providerDiagnostics") }}</span>
      <pre class="ai-summary-card__value">{{ formatJsonBlock(diagnostics) }}</pre>
    </div>

    <div v-if="resultPayload" class="ai-summary-card ai-summary-card--nested">
      <span class="ai-summary-card__label">{{ resultLabel }}</span>
      <pre class="ai-summary-card__value">{{ formatJsonBlock(resultPayload) }}</pre>
    </div>
  </article>
</template>

<script>
import { formatJsonBlock, formatRunStatus, runStatusColor } from "./aiWorkspaceShared.mjs";
import { formatDurationLabel } from "./aiRunObservability.mjs";
import {
  buildRunAttemptDiagnostics,
  extractRunAttemptErrorMessage,
  isFailedRunAttempt,
  resolveRunAttemptResultPayload,
} from "./aiRunsDiagnostics.mjs";

export default {
  name: "AiRunAttemptCard",
  props: {
    attempt: {
      type: Object,
      required: true,
    },
  },
  computed: {
    diagnostics() {
      return buildRunAttemptDiagnostics(this.attempt);
    },
    durationLabel() {
      return formatDurationLabel(this.attempt?.observability?.duration_ms);
    },
    errorMessage() {
      return extractRunAttemptErrorMessage(this.attempt);
    },
    taxonomyLabel() {
      return this.attempt?.observability?.error_taxonomy?.label || null;
    },
    resultLabel() {
      return isFailedRunAttempt(this.attempt)
        ? this.$t("ncrm.ai.runs.labels.providerResponse")
        : this.$t("ncrm.ai.runs.labels.attemptResult");
    },
    resultPayload() {
      return resolveRunAttemptResultPayload(this.attempt);
    },
  },
  methods: {
    formatJsonBlock,
    formatRunStatus,
    runStatusColor,
  },
};
</script>
